import { useQuery } from "@tanstack/react-query";
import { api } from "../utils/hostname";
import url from "../url";
import { GameType } from "../types/Games";

export const useGetGamesByIds = (gameIds: string[], enabled?: boolean) => {
  const { data, isLoading } = useQuery({
    queryKey: ["game ids", gameIds.join("")],
    queryFn: () =>
      api(true, true).get<GameType[]>(url.config.api.games.gamesIds, {
        params: {
          gameIds,
        },
      }),
    enabled: gameIds.length > 0 && !!enabled,
    staleTime: Infinity,
  });

  return {
    games: data?.data || [],
    isLoading,
  };
};
